import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';

// Create query and mutation caches with error handlers
const queryCache = new QueryCache({
  onError: (error) => {
    console.error('Query cache error:', error);
    // You can add global error handling here, like showing a toast notification
  },
});

const mutationCache = new MutationCache({
  onError: (error) => {
    console.error('Mutation cache error:', error);
    // You can add global error handling here, like showing a toast notification
  },
});

// Create a client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
      retry: 1, // default: 3
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
    mutations: {
      retry: 1,
    }
  },
  queryCache,
  mutationCache,
});
